<form name="form" class="form-horizontal create-cronograma-fungicidas" ng-submit="$create.save()">
  <div class="modal-header">
    <h4 class="modal-title">Novo cronograma</h4>
  </div>
  <div class="modal-body">

    <div class="form-group" ng-class="{ 'has-error': form.safra.$invalid && form.safra.$dirty }">
      <label for="safra" class="control-label col-xs-5">Safra</label>
      <div class="col-xs-7">
        <select
          name="safra"
          id="safra"
          class="form-control"
          ng-options="safra.descricao for safra in $root.safras"
          ng-model="$create.cronograma.safra"
          ng-change="$create.changeSafra()"
          required
        ></select>
      </div>
    </div>
    <div class="form-group" ng-class="{ 'has-error': form.atividade.$invalid && form.atividade.$dirty }">
      <label for="atividade" class="control-label col-xs-5">Atividade</label>
      <div class="col-xs-7">
        <select
          name="atividade"
          id="atividade"
          class="form-control"
          ng-options="atividade.descricao for atividade in $create.atividades"
          ng-model="$create.cronograma.atividade"
          ng-change="$create.changeAtividade()"
          required
        ></select>
      </div>
    </div>
    <div class="form-group" ng-class="{ 'has-error': form.gleba.$invalid && form.gleba.$dirty }">
      <label for="gleba" class="control-label col-xs-5">Talhão</label>
      <div class="col-xs-7">
        <select
          name="gleba"
          id="gleba"
          class="form-control"
          ng-options="gleba.descricao for gleba in $create.glebasAtividade"
          ng-model="$create.cronograma.gleba"
          ng-change="$create.changeGleba()"
          required
        ></select>
      </div>
    </div>
    <div class="form-group" ng-class="{ 'has-error': form.cultivar.$invalid && form.cultivar.$dirty || $create.messages.error }">
      <label for="cultivar" class="control-label col-xs-5">Cultivar</label>
      <div class="col-xs-7">
        <select
          name="cultivar"
          id="cultivar"
          class="form-control"
          ng-options="cultivar.descricao for cultivar in $create.cultivares"
          ng-model="$create.cronograma.cultivar"
          ng-change="$create.changeCultivar()"
          required
        ></select>
        <p class="text-danger" ng-show="$create.messages.error">
          {{$create.messages.error}}
        </p>
      </div>
    </div>
    <div class="form-group" ng-class="{
      'has-error': form.area.$invalid && form.area.$dirty,
      'has-warning': $create.formWarnings.area.text
    }"
      >
      <label for="area" class="control-label col-xs-5">Área</label>
      <div class="col-xs-7">
        <div class="input-group">
          <input
            type="number"
            name="area"
            id="area"
            step="any"
            min="0.01"
            required
            ng-model="$create.cronograma.area"
            class="form-control"
          >
          <span class="input-group-addon">
            ha
          </span>
        </div>
        <p class="text-warning" ng-show="$create.formWarnings.area.text">
          {{$create.formWarnings.area.text}}
        </p>
      </div>

    </div>
    <div class="form-group" ng-class="{ 'has-error': form.plantio.$invalid && form.plantio.$dirty }">
      <label for="plantio" class="control-label col-xs-5">Plantio</label>
      <div class="col-xs-7">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Data"
            ng-model="$create.datepickerTextArea.plantio"
            ng-change="$create.setCronogramaDate('plantio')"
            text-mask="$create.DATE_MASK"
            required
          >
          <input
            class="hidden-datapicker"
            datepicker-options="$create.datapickerPlantioOptions"
            ng-change="$create.setTextDatapicker('plantio'); $create.changePlantioCiclo();"
            uib-datepicker-popup="dd/MM/yyyy"
            ng-model="$create.cronograma.plantio"
            is-open="$create.datepickerPlantio.open"
            id="plantio"
            name="plantio"
            popup-placement="bottom-left"
            required
          >
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="$create.datepickerPlantio.open = !$create.datepickerPlantio.open">
              <i class="glyphicon glyphicon-calendar"></i>
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="form-group" ng-class="{ 'has-error': form.ciclo.$invalid && form.ciclo.$dirty, 'has-warning': $create.messages.warning }">
      <label for="ciclo" class="control-label col-xs-5">Ciclo</label>
      <div class="col-xs-7">
        <div class="input-group">
          <input
            type="number"
            name="ciclo"
            id="ciclo"
            step="1"
            min="1"
            max="366"
            required
            ng-model="$create.cronograma.ciclo"
            ng-change="$create.changePlantioCiclo()"
            class="form-control"
          >
          <span class="input-group-addon">
            dias
          </span>
        </div>
        <p class="text-warning" ng-show="$create.messages.warning">
          {{$create.messages.warning}}
        </p>
      </div>
    </div>
    <div class="form-group" ng-class="{ 'has-error': form.emergencia.$invalid && form.emergencia.$dirty, 'has-warning': $create.messages.warning }">
      <label for="emergencia" class="control-label col-xs-5">Emergência</label>
      <div class="col-xs-7">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Data"
            ng-model="$create.datepickerTextArea.emergencia"
            ng-change="$create.setCronogramaDate('emergencia')"
            text-mask="$create.DATE_MASK"
            required
          >
          <input
            class="hidden-datapicker"
            datepicker-options="$create.datepickerOptions"
            ng-change="$create.updateFirstApplicationDate('emergence'); $create.setTextDatapicker('emergencia');"
            uib-datepicker-popup="dd/MM/yyyy"
            ng-model="$create.cronograma.emergencia"
            is-open="$create.datepickerEmergencia.open"
            id="emergencia"
            min-date="$create.cronograma.plantio"
            name="emergencia"
            popup-placement="bottom-left"
            required
          >
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="$create.datepickerEmergencia.open = !$create.datepickerEmergencia.open">
              <i class="glyphicon glyphicon-calendar"></i>
            </button>
          </span>
        </div>
        <p class="text-warning" ng-show="$create.messages.warning">
          {{$create.messages.warning}}
        </p>
      </div>
    </div>
    <div class="form-group">
      <label for="daysFromEmergence" class="control-label col-xs-5">
        Dias após a emergência
        <i
          class="fa fa-question-circle text-muted"
          uib-tooltip="
            Quantos dias após a emergência será a primeira aplicação. Também é possível editar o campo abaixo
            para especificar uma data caso não tenha este número definido.
          "
          tooltip-placement="right"
          tooltip-append-to-body="true"
        ></i>
      </label>
      <div class="col-xs-7">
        <input
          type="number"
          class="form-control"
          id="daysFromEmergence"
          name="daysFromEmergence"
          ng-model="$create.daysFromEmergence"
          ng-change="$create.updateFirstApplicationDate('days')"
        >
      </div>
    </div>
    <div class="form-group" ng-class="{ 'has-error': form.first.$invalid && form.first.$dirty }">
      <label for="first" class="control-label col-xs-5">Primeira aplicação</label>
      <div class="col-xs-7">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Data"
            ng-model="$create.datepickerTextArea.first"
            ng-change="$create.setCronogramaDate('first')"
            text-mask="$create.DATE_MASK"
            required
          >
          <input
            class="hidden-datapicker"
            datepicker-options="$create.datepickerOptions"
            uib-datepicker-popup="dd/MM/yyyy"
            ng-model="$create.cronograma.first"
            id="first"
            name="first"
            is-open="$create.datepickerFirst.open"
            show-button-bar="false"
            datepicker-append-to-body="true"
            min-date="$create.cronograma.plantio"
            ng-change="$create.updateFirstApplicationDate('first'); $create.setTextDatapicker('first');"
            popup-placement="bottom-left"
            required
          >
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="$create.datepickerFirst.open = !$create.datepickerFirst.open">
              <i class="glyphicon glyphicon-calendar"></i>
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="form-group" ng-class="{ 'has-error': form.colheitaEstimada.$invalid && form.colheitaEstimada.$dirty }">
      <label for="colheitaEstimada" class="control-label col-xs-5">Data estimada de colheita</label>
      <div class="col-xs-7">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Data"
            ng-model="$create.datepickerTextArea.colheitaEstimada"
            ng-change="$create.setCronogramaDate('colheitaEstimada')"
            text-mask="$create.DATE_MASK"
            required
          >
          <input
            class="hidden-datapicker"
            datepicker-options="$create.datepickerOptions"
            uib-datepicker-popup="dd/MM/yyyy"
            ng-model="$create.cronograma.colheitaEstimada"
            id="colheitaEstimada"
            name="colheitaEstimada"
            is-open="$create.datepickerColheitaEstimada.open"
            show-button-bar="false"
            datepicker-append-to-body="true"
            min-date="$create.cronograma.emergencia"
            ng-change="$create.setTextDatapicker('colheitaEstimada');"
            popup-placement="bottom-left"
            required
          >
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="$create.datepickerColheitaEstimada.open = !$create.datepickerColheitaEstimada.open">
              <i class="glyphicon glyphicon-calendar"></i>
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="form-group" ng-class="{ 'has-error': form.quantidade.$invalid && form.quantidade.$dirty }">
      <label for="quantidade" class="control-label col-xs-5">Quantidade de Aplicações</label>
      <div class="col-xs-7">
        <input
          type="number"
          name="quantidade"
          id="quantidade"
          step="1"
          min="1"
          required
          ng-model="$create.cronograma.quantidade"
          class="form-control"
        >
      </div>
    </div>
    <div class="form-group" ng-class="{ 'has-error': form.intervalo.$invalid && form.intervalo.$dirty }">
      <label for="intervalo" class="control-label col-xs-5">Intervalo entre aplicações</label>
      <div class="col-xs-7">
        <input
          type="number"
          name="intervalo"
          id="intervalo"
          step="1"
          min="1"
          required
          ng-model="$create.cronograma.intervalo"
          class="form-control"
        >
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-link" ng-click="$dismiss()" ng-disabled="edit.loading">
      Cancelar
    </button>
    <button type="submit" class="btn btn-success" ng-disabled="form.$invalid || $create.loading">
      <i class="fa fa-spinner fa-pulse fa-fw text-white" ng-if="$create.loading"></i>
      Salvar
      <i class="fa fa-check"></i>
    </button>
  </div>
</form>
